import { cn } from "@/lib/utils";
import Link from "next/link";
import { Logo } from "../logo";
import { UserMenu } from "./user-menu";
export { OrangeHeader } from "./orange-header";

export function Header({ hideElements = false }: { hideElements?: boolean }) {
  return (
    <header
      className={cn(
        "z-50 bg-white xl:bg-transparent border-muted xl:border-0 border-b w-full ",
        hideElements && "xl:bg-[#E5684A] xl:bg-[url(/pattern-primary.svg)]"
      )}
    >
      <div className="flex justify-between items-center mx-auto xl:p-4 px-4 w-full container">
        <Link href="/" className="block w-[31px] xl:w-1/2 truncate">
          <Logo className="xl:hidden w-[190px] xl:w-[380px]" />
          <Logo
            className="hidden xl:block w-[190px] xl:w-[380px]"
            color="white"
          />
        </Link>
        {!hideElements && (
          <h1 className="xl:hidden block font-medium text-secondary text-xs md:text-sm">
            Painel de votação
          </h1>
        )}
        <UserMenu />
      </div>
    </header>
  );
}
